import { Component, Input, OnInit } from '@angular/core';
import { CofOStatusDto } from '@cradua/data';

@Component({
  selector: 'cradua-c-of-o',
  templateUrl: './c-of-o.component.html',
  styleUrls: ['./c-of-o.component.scss']
})
export class COfOComponent implements OnInit {

  @Input() cofOStatus: CofOStatusDto[];

  constructor() { }

  ngOnInit(): void {
  }

}
